export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11824.6c3be17f.jpg";